import { NavLink, Outlet } from 'react-router-dom';

const tabs = [
  { to: '/admin/content/settings', label: '網站設定' },
  { to: '/admin/content/organization', label: '組織架構' },
  { to: '/admin/content/issues', label: '核心服務' },
  { to: '/admin/content/blog', label: '最新消息' },
];

const ContentAdmin = () => (
  <div className="admin-page">
    <h1>內容管理</h1>
    <nav className="content-tabs" aria-label="內容管理">
      {tabs.map((tab) => (
        <NavLink key={tab.to} to={tab.to} className={({ isActive }) => (isActive ? 'active' : undefined)}>
          {tab.label}
        </NavLink>
      ))}
    </nav>
    <Outlet />
  </div>
);

export default ContentAdmin;
